import { IconProps } from '@tamagui/helpers-icon';
import { Pressable } from '@unistocks/components/basic/pressable';
import { Paragraph } from '@unistocks/components/text/text';
import { PropsWithRef } from '@unistocks/types';
import React from 'react';
import { Circle } from 'tamagui';

export type HeaderButtonProps = PropsWithRef<
  IconProps & {
    Icon: React.ComponentType<IconProps>;
    badge?: number;
  },
  typeof Pressable
>;

export const HeaderButton: React.FC<HeaderButtonProps> = ({
  ref,
  onPress,
  Icon,
  badge,
  ...props
}) => (
  <Pressable
    ref={ref}
    withFeedback
    withScale
    hitSlop={12}
    cursor={onPress ? 'pointer' : 'default'}
    onPress={onPress}
  >
    <Icon color={'$headingFont'} size={'$2.5'} {...props} />
    {badge ? (
      <Circle
        size={18}
        justifyContent="center"
        alignItems="center"
        bg={'$unistocks'}
        position="absolute"
        top={-6}
        right={-6}
      >
        <Paragraph color={'$gray1'} size={'$1'}>
          {badge}
        </Paragraph>
      </Circle>
    ) : null}
  </Pressable>
);
